import React, { Fragment, useContext } from 'react';
import { StaticContext } from '@sm/webassets';
import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { PricingData } from './types';

import DetailsPackageHeader from '~pricing/components/DetailsTable/PackageHeader';
import Categories from '~app/pages/Pricing/components/DetailsTable/Categories';
import useTreatment from '~pricing/hooks/useTreatment';

import useDetailsStyles from './useStyles';

export default function DetailsPackagesView({ packageData, discountInfo }: PricingData): JSX.Element {
  const { Details, Sticky, Mobile, Desktop } = useDetailsStyles({
    packageCount: packageData.length,
  });
  const {
    uiExperiment: { GROW_2529_FORMS_TREATMENT1, GROW_2529_FORMS_TREATMENT2, GROW_2629_FORMS_V2_TREATMENT },
  } = useTreatment();

  const { ssrEnv } = useContext(StaticContext);

  if (!packageData) {
    return <></>;
  }

  const GROW_2529_TREATMENT = GROW_2629_FORMS_V2_TREATMENT || GROW_2529_FORMS_TREATMENT1 || GROW_2529_FORMS_TREATMENT2;

  return (
    <Box className={Details}>
      <Responsive maxWidth="md" defaultMatches={ssrEnv?.isMobile}>
        <Box className={Mobile}>
          {packageData.map((pricingPackage, index: number) => {
            if (pricingPackage) {
              const { comparisonSkuCost, skuCost, packageName } = pricingPackage;
              const packageClassName = GROW_2529_FORMS_TREATMENT2 ? '' : `package-${packageName}`;
              return (
                <div key={`Mobile-${packageName}`} className={packageClassName}>
                  {GROW_2529_TREATMENT ? (
                    <GROW_2529_TREATMENT.DetailsPackageHeader
                      comparisonSkuCosts={comparisonSkuCost}
                      discountInfo={discountInfo}
                      skuCosts={skuCost}
                      packageName={packageName}
                      index={`${index + 1}`}
                      data-testid="DetailsPackagesView__PackageHeader"
                    />
                  ) : (
                    <DetailsPackageHeader
                      comparisonSkuCosts={comparisonSkuCost}
                      discountInfo={discountInfo}
                      skuCosts={skuCost}
                      packageName={packageName}
                      index={`${index + 1}`}
                      data-testid="DetailsPackagesView__PackageHeader"
                    />
                  )}
                  <Categories displayedPackages={[pricingPackage]} isMobile />
                </div>
              );
            }
            return null;
          })}
        </Box>
      </Responsive>

      <Responsive minWidth="md" defaultMatches={ssrEnv?.isDesktop}>
        <Box className={Desktop}>
          <Box className={Sticky} id="PackagesHeader" data-testid="DetailsPackagesView__Sticky">
            {packageData.map((pricingPackage, index: number) => {
              if (pricingPackage) {
                const { comparisonSkuCost, skuCost, packageName } = pricingPackage;
                return (
                  <Fragment key={`DetailsHeader-Desktop-Container${packageName}`}>
                    {GROW_2529_TREATMENT ? (
                      <GROW_2529_TREATMENT.DetailsPackageHeader
                        key={`DetailsHeader-Desktop${packageName}`}
                        comparisonSkuCosts={comparisonSkuCost}
                        discountInfo={discountInfo}
                        skuCosts={skuCost}
                        packageName={packageName}
                        index={`${index + 1}`}
                      />
                    ) : (
                      <DetailsPackageHeader
                        key={`DetailsHeader-Desktop${packageName}`}
                        comparisonSkuCosts={comparisonSkuCost}
                        discountInfo={discountInfo}
                        skuCosts={skuCost}
                        packageName={packageName}
                        index={`${index + 1}`}
                      />
                    )}
                  </Fragment>
                );
              }
              return null;
            })}
          </Box>
          <Categories displayedPackages={packageData} />
        </Box>
      </Responsive>
    </Box>
  );
}
